import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/global.css';
import './styles/v3.css';
import './styles/accessibility.css';
import './styles/responsive.css';
import './styles/layout.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The app routes with a HashRouter (URLs are /#/route). A link that arrives WITHOUT the hash —
// e.g. an older invitation mail's https://host/activate-account?token=… — loads the root and the
// router never sees the route (the token was silently dropped and the login page showed). Fold such
// a path + query into the hash route before React mounts, so every deep link keeps working.
(() => {
  const { pathname, search, hash } = window.location;
  const isFile = /\.[a-z0-9]{2,5}$/i.test(pathname);            // static assets / site pages
  const isSite = pathname.startsWith('/site/');
  if (pathname && pathname !== '/' && !isFile && !isSite && (!hash || hash === '#' || hash === '#/')) {
    window.location.replace(`/#${pathname}${search}`);
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
